import configManager from "../singleton/ConfigManager";
import { getThemeColor, onThemeChanged } from "../utils/theme";

/**
 * Positions the HUD and toggles app mode based on where the user is looking
 * @namespace ui
 * @component hud-controller
 */
AFRAME.registerComponent("hud-controller", {
  schema: {},
  init() {
    // Existing initialization code
    this.onChildHovered = this.onChildHovered.bind(this);
    this.removeHoverEvents = this.removeHoverEvents.bind(this);
    this.hideHud = this.hideHud.bind(this);
    this.store = window.APP.store;
    this.hoverableChildren = this.el.querySelectorAll("[is-remote-hover-target]");

    this.inWorldHub = this.el.querySelector(".in-world-hud");
    this.inWorldHub.object3D.visible = false;

    this.menuButton = this.el.querySelector(".hud.open-menu-button");
    this.menuButtonSprite = this.menuButton.querySelector("a-entity[icon-button]");
    this.menuButton.object3D.addEventListener("interact", () => {
      this.inWorldHub.object3D.visible = !this.inWorldHub.object3D.visible;
      this.menuButtonSprite.setAttribute("icon-button", "active", this.inWorldHub.object3D.visible);
    });

    this.updateTheme = () => {
      const primaryColor = getThemeColor("primary-color");
      const primaryHoverColor = getThemeColor("primary-color-hover");
      this.menuButton.setAttribute(
        "text-button",
        `backgroundColor: ${primaryColor}; backgroundHoverColor: ${primaryHoverColor}`
      );
    };
    this.updateTheme();
    this.removeThemeListener = onThemeChanged(this.updateTheme);

    this.onHover = () => {
      this.menuButton.setAttribute("slice9", "opacity", 1);
    };
    this.onUnhover = () => {
      if (!this.inWorldHub.object3D.visible) {
        this.menuButton.setAttribute("slice9", "opacity", 0.5);
      }
    };
  },

  tick() {
    if (!this.el.getAttribute("visible")) {
      this.inWorldHub.object3D.visible = false;
      this.menuButtonSprite.setAttribute("icon-button", "active", false);
      this.onUnhover();
      return;
    }
  },

  // Existing play/pause/hover methods
  play() {
    this.menuButton.object3D.addEventListener("hovered", this.onHover);
    this.menuButton.object3D.addEventListener("unhovered", this.onUnhover);
    this.el.sceneEl.addEventListener("camera-movement-detected", this.hideHud);
    this.el.sceneEl.addEventListener("camera-rotation-detected", this.hideHud);
    this.el.sceneEl.addEventListener("selected", this.hideHud);

    for (let i = 0; i < this.hoverableChildren.length; i++) {
      this.hoverableChildren[i].object3D.addEventListener("hovered", this.onChildHovered);
    }
  },

  pause() {
    this.el.sceneEl.removeEventListener("camera-movement-detected", this.hideHud);
    this.el.sceneEl.removeEventListener("camera-rotation-detected", this.hideHud);
    this.el.sceneEl.removeEventListener("selected", this.hideHud);
    this.removeHoverEvents();
  },

  remove() {
    this.removeThemeListener?.();
  },

  removeHoverEvents() {
    for (let i = 0; i < this.hoverableChildren.length; i++) {
      this.hoverableChildren[i].object3D.removeEventListener("hovered", this.onChildHovered);
    }
  },

  onChildHovered() {
    if (!this.store.state.activity.hasHoveredInWorldHud) {
      this.store.update({ activity: { hasHoveredInWorldHud: true } });
      this.removeHoverEvents();
    }
  },

  hideHud() {
    if (this.inWorldHub.object3D.visible) {
      this.inWorldHub.object3D.visible = false;
      this.menuButtonSprite.setAttribute("icon-button", "active", false);
      this.onUnhover();
    }
  }
});
